<template>
  <div>
    <Header header-text="3d Model Side Projects"></Header>
    <div class="blurb-container">
      <h1 class="blurb-title">Creative Commons work</h1>
      <div class="blurb-decoration-bar"></div>
        <p class="blurb-content">Many models that I've designed released under the Creative Commons license on <a href="https://www.thingiverse.com/Sambulance/designs"><b>thingiverse</b></a> </p>
        <div>
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/baseball_keychain.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/logitech_meetup_mount.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/pitt_keychain.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/rockola_button.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/rockola_r.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/rockola_stereo.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/seeburg_mini.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/seeburg_teardrop_logo.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/wurlitzer_large_diamond.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/wurlitzer_small_diamond.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/wurlitzer_letters.png" style="max-height:15em">
          <img class="w3-margin w3-card-4" src="../assets/3dmodels/x5s_mount.png" style="max-height:15em">
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>
<style>

.blurb-content {
  padding-bottom: 2em;
}

.myminifactorycard {
  margin-left: 1em;
  margin-right: 1em;
}
</style>